import request from "@/api";
import type { CustomAxiosRequestConfig } from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { TiandituSearch, TiandituVo } from "@zhihaoscm/entity";

export class TiandituService extends BaseService<TiandituSearch, TiandituVo, any, any> {
    /**
     * 行政区划区域
     */
    public async search(params: TiandituSearch): Promise<TiandituVo> {
        const { data } = await this.service.post(`${this.path}/search?type=query`, params, {
            loading: false
        } as CustomAxiosRequestConfig);
        return data;
    }
}
export const tiandituService = new TiandituService("/admin/tianditu", request.service);
